import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("accessToken");
    const loggedInUserId = localStorage.getItem("loggedInUserId");
    const defaultFarmId = localStorage.getItem("defaultFarmId");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (loggedInUserId) {
        config.headers["X-User-Id"] = loggedInUserId;
    }   
    if (defaultFarmId) {
        config.headers["X-Farm-Id"] = defaultFarmId;
    }  

    return config;
});

export default api;
